import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RelevancyFeedback, RelevancyFeedbackRequest } from '../entities/relevancy-feedback.model';
import { LerApiService } from './ler-api.service';

@Injectable({ providedIn: 'root' })
export class RelevancyFeedbackApiService extends LerApiService {
  private readonly endpoint = '/v1/ler/relevancy_feedbacks';

  submitFeedback(payload: RelevancyFeedbackRequest): Observable<RelevancyFeedback> {
    return this._post(this.endpoint, payload).pipe(
      map((res) => this._handleResponse(res, 'relevancy_feedback')),
      catchError((res) => this._handleError(res)),
    );
  }
}
